import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  RemoveAuctionReminderMutation,
  RemoveAuctionReminderMutationVariables,
} from './__generated__/useRemoveReminder.graphql.ts';

const REMOVE_REMINDER = gql`
  mutation RemoveAuctionReminderMutation(
    $input: removeAuctionReminderInput!
    $sport: Sport!
  ) {
    removeAuctionReminder(input: $input) {
      auction {
        id
        myReminder {
          id
          enabled
        }
      }
      currentUser {
        slug
        involvedLiveTokenAuctions(first: 10, sport: [$sport]) {
          nodes {
            id
          }
        }
      }
      errors {
        code
        message
      }
    }
  }
` as TypedDocumentNode<
  RemoveAuctionReminderMutation,
  RemoveAuctionReminderMutationVariables
>;

type Props = {
  id: string;
  reminder: {
    id: string;
  };
};

export const useRemoveReminder = () => {
  const { sport } = useSportContext();
  const [removeReminder, { loading }] = useMutation(REMOVE_REMINDER, {
    showErrorsWithSnackNotification: true,
  });

  return {
    removeReminder: async ({ reminder }: Props) => {
      const { data } = await removeReminder({
        variables: { input: { auctionReminderId: reminder.id }, sport },
      });
      return data?.removeAuctionReminder?.auction?.myReminder;
    },
    loading,
  };
};
